import React from 'react';
import { BrandColors } from 'v2/styles/BrandColors';

interface IBaseIconProps {
  fillColor?: string;
  stroke?: string;
  fillOpacity?: string;
}

const BaseClockIcon = ({
  fillColor = BrandColors.primary,
  stroke = 'white',
  fillOpacity = '100%',
}: IBaseIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="-1 -1 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="11"
        cy="11"
        r="11"
        fill={fillColor}
        fillOpacity={fillOpacity}
        stroke={stroke}
        strokeWidth={2}
      />
      <path
        d="M10.4706 4.50144L10.4706 12.5015L14.499 15.4982"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

interface IExpiredClockIconProps {
  /** defalut 'red' */
  hue?: 'red' | 'blue';
}

export const ExpiredClockIcon = ({ hue = 'red' }: IExpiredClockIconProps) => {
  const color = hue === 'red' ? BrandColors.alert : BrandColors.primary;
  return <BaseClockIcon fillColor={color} fillOpacity="10%" stroke={color} />;
};

export const ClockIcon = () => (
  <BaseClockIcon
    fillColor={BrandColors.primary}
    fillOpacity="100%"
    stroke="white"
  />
);
